<template>
    <div v-for="(channel, index) in props.channels" :key="channel.id" :class="[
        'w-full px-4 py-2 bg-white flex items-center justify-between gap-3 rounded rounded-bl-none rounded-br-none cursor-pointer hover:bg-muted',
        index <= (channels.length - 1) ? 'border-b border-gray-200 last:border-b-0' : ''
        ]" @click="selectChannel(channel)">

        <!-- アバター画像 -->
        <div class="w-8 h-8 relative shrink-0">
            <div class="absolute w-8 h-8 left-0 top-0 bg-white rounded-full border border-[#DFE4EC]"></div>
            <img :src="channel.channel_icon" alt="avatar" class="absolute w-8 h-8 left-0 top-0 rounded-full object-cover">
        </div>

        <!-- チャンネル名とハンドル名 -->
        <div class="flex flex-col justify-start flex-1 min-w-0 items-start gap-0.5">
            <div class="w-full text-main text-sm font-semibold leading-5 break-words truncate">{{ channel.channel_name }}</div>
            <div class="w-full text-main text-xs font-light leading-4 break-words truncate">@{{ channel.account_name }}</div>
        </div>

        <!-- アイコン（右側） -->
        <div v-if="channel.id == props.currentChannel.id" class="w-5 h-5 relative overflow-hidden shrink-0">
            <i class="fa-solid fa-check text-main"></i>
        </div>
    </div>
    <div v-if="!isOwnerChannel" class="w-full h-[46px] px-4 py-2 bg-white rounded rounded-tl-none rounded-tr-none justify-start items-center gap-3 inline-flex cursor-pointer hover:bg-muted" @click="createChannel()">
        <div class="w-[30px] px-2 flex flex-col justify-center items-center gap-[10px] inline-flex">
            <i class="fa-thin fa-plus"></i>
        </div>
        <div class="text-main text-[12px] font-light leading-4 truncate w-full">
            新規チャンネルを登録
        </div>
    </div>
</template>

<script setup>
import {
    defineProps,
    defineEmits,
    computed,
} from 'vue'

const props = defineProps({
    channels: {
        type: Array,
        default: () => [],
    },
    currentChannel: {
        type: Object,
        default: () => {},
    }
});

const emit = defineEmits([
    "channel-selected",
    "close-channel-list",
    "create-channel",
]);

const selectChannel = (channel) => {
    if (channel.id !== props.currentChannel.id) {
        emit('channel-selected', channel.id);
    } else {
        emit('close-channel-list');
    }
};

const createChannel = () => {
    emit('create-channel');
};

const isOwnerChannel = computed(() => {
    return props.channels.some(channel => channel.is_owner);
});
</script>
